import { useEffect, useState, useCallback } from "react"
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { Configuration, khasaraTitle } from "../../../constants";
import { Container, Card } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import routes from "../../../routers/routes";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import Table from "../../table/Table";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";


const Khasara = () => {

    const navigate = useNavigate();
    const [khasaraDetails, setKhasaraDetails] = useState([]);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedKhasaraId, setSelectedKhasaraId] = useState('');
 
    
    const role = useAppSelector(state => state.role.role);

    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy
    } = usePagination({
        endpoint: `/khasara`,
        filterOn:'KhasaraNo',
        enabled:true
    })
    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])
    /*useEffect(()=>{
         
        const fetchKhasaraDetails = async () =>{

            try{
                const response  = await ApiService.axiosApi('/khasara',{
                    method : 'GET'
                })

                if(response.success){
                   console.log(response.data)
                    toast.success(response.message || "Khasara details fetched successfully");  
                    setKhasaraDetails(response.data);
                }else{
                    toast.error(response.message || "Unable to fetch khasara details");
                }
            }catch(error){
                console.log(error);
                
            }
        }
        fetchKhasaraDetails();
    },[refresh])*/
    

    const handleDeleteKhasara = async (id: string) => {
        try {
            const response = await ApiService.axiosApi(`/khasara/${id}`, {
                method: 'DELETE'
            })
            if (response.success) {
                console.log(response.data)
                toast.success(response.message || "khasara delteted successfully");
                setRefresh(prev => !prev);
                setIsDeleteModalOpen(false);
            } else {
                toast.error(response.message);
            }

        } catch (error: any) {
            toast.error(error.message);
        }
    }

    const handleKhasaraUpdate = (id: string) => {
        navigate(`/khasara-update/${id}`);
    }

    const handleDelete = (id: string) => {

        setSelectedKhasaraId(id);
        setIsDeleteModalOpen(true);
    }
    return (
        <>
            <Breadcrumbs mainTitle={khasaraTitle} parent={Configuration} />
            <div className="tables">
                <Card>
                    <CommonCardHeader title="Khasara List" headClass="pb-3" />
                    <div className="d-flex justify-content-between">
                    <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                        <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                        </div>
                           <div>
                           <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('KhasaraNo')}>
                         <FilterIcon/>
                       </button>
                           </div>
                        
                    </div>
                    {role === "Administrator" && (
                        <div className="d-flex justify-content-end">
                            <Button onClick={() => navigate(routes.AddKhasara)} color="primary" className="mb-2 mx-2">Add Khasara</Button>
                        </div>
                    )}
                    </div>


                    <Table data={data} columns={[
                        { header: "Khasara Number ", accessor: "khasaraNo" },
                        { header: "Ownership Detail", accessor: "ownershipDetail" },
                        { header: "Address", accessor: "address" },
                        { header: "Contact Number", accessor: "contactNumber" },
                        { header: "Scheme/Village", accessor: "scheme_Village" },
                        { header: "Farmer Name", accessor: "farmer" },
                        { header: "Area", accessor: "area" },

                    ]}
                        buttons={[
                            { label: "Edit", onClick: handleKhasaraUpdate, color: "primary", className: "me-2" },
                            { label: "Delete", onClick: handleDelete, color: "danger" }
                        ]}
                    />
                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>

                </Card>
                <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
                    <ModalHeader>Delete Khasara</ModalHeader>
                    <ModalBody>Are you sure you want to delete this khasara?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => handleDeleteKhasara(selectedKhasaraId)}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>
    )
}
export default Khasara;